module.exports = __webpack_public_path__ + "img/16131231007.TCC.5eab6934.svg";